

































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { Order } from '@/models/order';
import { APP_CONFIG } from '@/config/app-config';
import orderServices from '@/services/order-service';
import authService from '@/services/auth-services';
import u from '@/utility/utility';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';

@Component({
    components: {
        ConfirmModal,
        Loading
    }
})
export default class ListOrder extends Vue {
    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckAll: 'eventCheckAll'
    };

    private actions = {
        cancel: 'cancel',
        deposit: 'deposit',
        complain: 'complain',
        duplicate: 'duplicate',
        addToCart: 'addToCart'
    };
    private actionSelected: any = this.actions.cancel;

    private isCheckAll = false;

    @Prop({ default: () => [] })
    private listOrder!: Order[];

    @Prop({ default: () => ({}) })
    private customerInfo: any;

    private selectedOrder!: Order;
    private showNextConfirm = true;
    private isConfirm = false;
    private isLoading = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo || {};
    }

    @Watch('listOrder', { immediate: true, deep: true })
    private async watchListOrder() {
        if (!this.listOrder) {
            return;
        }
        const totalChecked = this.listOrder.filter(x => x.isChecked === true).length;
        const totalAllowCheck = this.listOrder.filter(x => x.status === 0 || x.status === 3 || x.status === 7 || x.status === 9 || x.status === 13).length;

        this.isCheckAll = totalChecked === totalAllowCheck && totalAllowCheck > 0;
    }

    private async onCancelOrder() {
        this.isLoading = true;
        const dataRequest = {
            Status: 1
        };

        const result = await orderServices.updateOrder(this.selectedOrder.id, dataRequest);

        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn hàng thành công!',
            });

            this.$emit(this.eventEmit.eventReloadOrder);
            this.isLoading = false;
        }
    }

    private async onDepositOrder() {
        if (this.customerInfo.Wallet >= this.selectedOrder.minDeposit) {
            const dataRequest = {
                Status: 2,
                Deposit: this.selectedOrder.minDeposit
            };

            const result = await orderServices.updateOrder(this.selectedOrder.id, dataRequest);
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Đặt cọc thành công!',
                });
                this.$emit(this.eventEmit.eventReloadOrder);
                this.getCustomersInfo();
            }
        } else {
            this.modalContent = '<div style="color: #111;">Số tiền trong ví của bạn không đủ để đặt cọc.</div><div class="text-danger">Hãy nạp tiền để tiếp tục đặt cọc!</div>';
            this.isConfirm = true;
            this.showNextConfirm = false;
        }
    }

    private async onActionStatus(order: Order, action: any) {
        this.actionSelected = action;
        this.selectedOrder = order;
        this.isConfirm = true;

        switch (this.actionSelected) {
            case this.actions.cancel: {
                this.modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.deposit: {
                this.modalContent = `<div style="color: #111">Số tiền bạn cần đặt cọc là <label class="fb text-danger">${formatNumber(this.selectedOrder.minDeposit, '0,0')} vnd.</label>
                                    <div>Bạn có muốn đặt cọc không?</div></div>`;
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.duplicate: {
                this.modalContent = 'Bạn có thực sự muốn tạo đơn hàng mới giống đơn hàng này, bao gồm cả danh sách khai báo không?';
                this.showNextConfirm = true;
                break;
            }
            case this.actions.addToCart: {
                this.modalContent = 'Bạn có muốn thêm toàn bộ sản phẩm của đơn hàng này vào giỏ hàng không?';
                this.showNextConfirm = true;
                break;
            }
            case this.actions.complain: {
                this.$router.push({
                    name: 'order-complain',
                    params: {
                        orderId: this.selectedOrder.id.toString()
                    }
                });
                this.isConfirm = false;
                break;
            }
        }
    }

    private async onCloseModal(event: any) {
        this.isConfirm = false;
    }

    private async onAcceptModal(event: any) {
        this.isConfirm = false;
        switch (this.actionSelected) {
            case this.actions.cancel: {
                await this.onCancelOrder();
                break;
            }
            case this.actions.deposit: {
                await this.onDepositOrder();
                break;
            }
            case this.actions.duplicate: {
                await this.onDuplicateOrder();
                break;
            }
            case this.actions.addToCart: {
                await this.onAddOrderToCart();
                break;
            }
        }
    }

    private async onDuplicateOrder() {
        this.isLoading = true;
        const dataRequest = {
            order_id: this.selectedOrder.id,
            ID: this.selectedOrder.id
        };
        const result = await orderServices.duplicateOrder(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo đơn hàng thành công!',
            });
            const newOrderId = (result.data.data && (result.data.data.ID || result.data.data.id)) || (result.data && (result.data.ID || result.data.id));
            if (newOrderId) {
                this.$router.push({
                    name: 'order-detail',
                    params: {
                        orderId: newOrderId.toString()
                    }
                });
            }
        } else {
            const msg = (result && result.data && (result.data.error || result.data.reason || result.data.message)) || 'Có lỗi xảy ra khi sao chép đơn hàng!';
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi!',
                text: msg,
            });
        }
    }

    private async onAddOrderToCart() {
        this.isLoading = true;
        const dataRequest = {
            order_id: this.selectedOrder.id,
            ID: this.selectedOrder.id
        };
        const result = await orderServices.addOrderToCart(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Đã thêm đơn hàng vào giỏ thành công!',
            });
            this.$router.push({
                name: 'cart-index'
            });
        } else {
            const msg = (result && result.data && (result.data.error || result.data.reason || result.data.message)) || 'Có lỗi xảy ra khi thêm vào giỏ hàng!';
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi!',
                text: msg,
            });
        }
    }

    private async onCheckAllOrder() {
        this.listOrder.forEach(x => {
            if (x.status === 0 || x.status === 3 || x.status === 7 || x.status === 9 || x.status === 13) {
                x.isChecked = this.isCheckAll;
            }
        });
    }

    private proxyImage(url: string) {
        return u.proxyImage(url);
    }

    private viewOrder(order: Order) {
        this.$router.push({
            name: 'order-detail',
            params: {
                orderId: order.id.toString()
            }
        });
    }

    private getTimelineItems(order: Order) {
        return [
            { key: 'createdDate', label: 'Lên đơn', time: order.createdDate },
            { key: 'depositDate', label: 'Cọc đơn', time: order.depositDate },
            { key: 'waitBoughtDate', label: 'Chờ mua', time: order.waitBoughtDate },
            { key: 'waitPayment2Date', label: 'Chờ TT lần 2', time: order.waitPayment2Date },
            { key: 'boughtDate', label: 'Đã mua', time: order.boughtDate },
            { key: 'shopDeliverDate', label: 'Shop phát', time: order.shopDeliverDate },
            { key: 'storeCNImDate', label: 'Đến kho TQ', time: order.storeCNImDate },
            { key: 'storeCNExDate', label: 'Xuất kho TQ', time: order.storeCNExDate },
            { key: 'storeVNImDate', label: 'Nhập kho VN', time: order.storeVNImDate },
            { key: 'storeVNExDate', label: 'Xuất kho VN', time: order.storeVNExDate },
            { key: 'completedDate', label: 'Hoàn thành', time: order.completedDate },
        ];
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse || [];
    }

    private getWarehouseName(order: Order) {
        if (order.receivePlaceName) {
            return order.receivePlaceName;
        }
        const placeId = order.receivePlaceID || (this.customerInfo ? (this.customerInfo.ReceivePlaceID || this.customerInfo.receivePlaceID) : undefined);
        if (placeId) {
            const found = this.warehouse.find((w: any) => w.ID === placeId);
            if (found && found.Name) {
                return found.Name;
            }
            return `Kho #${placeId}`;
        }
        return this.warehouse && this.warehouse.length > 0 ? this.warehouse[0].Name : 'Kho Hà Nội';
    }

    private getWarehouseColor(order: Order) {
        let color = order.receivePlaceColor;
        const placeId = order.receivePlaceID || (this.customerInfo ? (this.customerInfo.ReceivePlaceID || this.customerInfo.receivePlaceID) : undefined);
        if (!color && placeId) {
            const found = this.warehouse.find((w: any) => w.ID === placeId);
            color = found && found.ColorCode ? found.ColorCode : (placeId === 6 ? '#00a421' : '#9333ea');
        }
        if (!color) {
            color = placeId === 6 ? '#00a421' : '#9333ea';
        }
        return color.startsWith('#') ? color : '#' + color;
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.ID);
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('AUTH_SET_CUSTOMER_INFO', result.data.data);
        }
    }
}
